// extracted by mini-css-extract-plugin
export default {"wrap":"MenuCategoryComponent_wrap__gbLfR","title":"MenuCategoryComponent_title__rY4R2","blockButton":"MenuCategoryComponent_blockButton__D8n5c"};